import { Menu, Transition } from "@headlessui/react";
import React, { Fragment, useEffect, useState } from "react";

import { useStringConstants } from "@/app/hooks/useStringConstants";
import { ChatBubbleLeftRightIcon, ChevronDownIcon, PhoneIcon } from "@heroicons/react/24/outline";
import clsx from "clsx";
import { IPhoneSelectDropdownComponentProps } from "@components/routes/auth_routes/CustomerProfile/customer_profile_interface";
import { IoMdArrowDropdown } from "react-icons/io";
import ClipboardComponent from "@/app/components/ui/Clipboard";
import { useUtils } from "@/app/hooks/useUtils";
import { FaCaretDown } from "react-icons/fa6";

const RenderMenuItem: React.FC<{
  phone: string;
  selected: string;
  isWhatsApp: boolean;
  isPrimary: boolean;
  handleSelectPet: (p: string) => void;
}> = ({ phone, selected, handleSelectPet, isWhatsApp, isPrimary }) => {
  const { mobileCountryCode } = useStringConstants();
  const { maskMobile } = useUtils();

  return (
    <Menu.Item key={phone}>
      {({ active }) => (
        <button
          onClick={() => {
            handleSelectPet(phone);
          }}
          className={`${active || selected === phone ? "bg-gray-900 text-white" : "text-gray-900"
            } group flex w-full justify-start items-center rounded-md px-2 py-2 text-xs`}
        >
          <PhoneIcon className="w-4 h-4 text-blue-600" />
          {isWhatsApp && <ChatBubbleLeftRightIcon className="w-4 h-4 ml-2 text-green-600" />}
          <span className="ml-2">
            {mobileCountryCode} {maskMobile(phone)}
          </span>
          {isPrimary && (
            <span className="inline-flex ml-1 items-center rounded-md bg-green-50 px-2 py-1 text-xs font-medium text-green-700 ring-1 ring-inset ring-green-600/20">
              Primary
            </span>
          )}
        </button>
      )}
    </Menu.Item>
  );
};

const PhoneSelectDropdownComponent: React.FC<IPhoneSelectDropdownComponentProps> = ({
  phoneNumbers,
  className,
  setSelectedPhone,
}) => {
  const [selected, setSelected] = useState<string>();
  const { maskMobile } = useUtils();

  const handleSelectPet = (phone: string) => {
    setSelected(phone);
    setSelectedPhone(phone);
  };

  useEffect(() => {
    if (selected) {
      //
    }
  }, [selected]);

  return (
    <div className={clsx("relative", className)}>
      <Menu as="div" className="relative inline-block text-left">
        <div>
          <Menu.Button className="flex justify-between items-center gap-2">
            <div className="flex items-center gap-1">{maskMobile(selected) ?? maskMobile(phoneNumbers?.mobile)}</div>
            <FaCaretDown className="w-3 h-3 text-balck cursor-pointer" />
          </Menu.Button>
        </div>
        <Transition
          as={Fragment}
          enter="transition ease-out duration-100"
          enterFrom="transform opacity-0 scale-95"
          enterTo="transform opacity-100 scale-100"
          leave="transition ease-in duration-75"
          leaveFrom="transform opacity-100 scale-100"
          leaveTo="transform opacity-0 scale-95"
        >
          <Menu.Items className="absolute mt-2 z-20 w-56 origin-top-right divide-y divide-gray-100 rounded-md bg-white shadow-lg ring-1 ring-black/5 focus:outline-none">
            <div className="px-1 py-1 ">
              {phoneNumbers?.mobile && (
                <RenderMenuItem
                  isPrimary
                  handleSelectPet={handleSelectPet}
                  phone={phoneNumbers?.mobile}
                  isWhatsApp={phoneNumbers?.isMobileWhatsapp}
                  selected={selected}
                />
              )}
              {phoneNumbers?.alternate ? (
                <RenderMenuItem
                  isPrimary={false}
                  handleSelectPet={handleSelectPet}
                  isWhatsApp={phoneNumbers?.isAlternateWhatsapp}
                  phone={phoneNumbers?.alternate}
                  selected={selected}
                />
              ) : (
                <span className="text-gray-500 text-xs text-center w-full inline-block border-t border-gray-100 py-1">
                  No Alternate Number
                </span>
              )}
            </div>
          </Menu.Items>
        </Transition>
      </Menu>
    </div>
  );
};

export default PhoneSelectDropdownComponent;
